export enum EditStatus {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOT_PERFORMED = 'NOT_PERFORMED',
    DELETE_SUCCESS = 'DELETE_SUCCESS',
}
